import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';
import { ReloadRequest } from '@/api/reload/ReloadRequest';
import { Envelope } from '@/types/envelope';

export default class ReloadResource extends KrpTechopsAdminResource {
  public async getAll(filterParams: string): Promise<Envelope> {
    const url: string = `/api/krp/admin/reload${filterParams}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    const envelope: Envelope = response.data;

    return envelope;
  }

  public async submitReloadJob(reloadRequest: ReloadRequest): Promise<any> {
    const url: string = '/api/krp/admin/reload';
    const response: AxiosResponse = await this.apiClient.post(url, reloadRequest);

    return response.data.data;
  }
}
